import { ApplicationCreateRequestStatus } from 'generatedTypes/flight/models';

export { ApplicationCreateRequestStatus as APPLICATION_CREATE_REQUEST_STATUS };

export const TEST_ID = 'createApplicationForm';
